import { ReactElement } from 'react';

import { PrismicRichText } from '@prismicio/react';

import { Accordion, AccordionItem } from '@components/atoms/Accordion';

import { IProps } from './types';
import * as S from './styles';

export function SliceAccordion({ slice: { fields } }: IProps): ReactElement {
  return (
    <S.Wrapper className="slice-item slice-accordion">
      {fields && (
        <Accordion multi>
          {fields.map((item, i) => (
            <AccordionItem
              title={item.title}
              uniqueKey={i}
              key={`slice-accordion-item-${i}`}
            >
              <S.ContentWrapper className="list-content">
                <div className="list-content-container">
                  {item.rich_text && (
                    <div className="list-content-column">
                      <PrismicRichText field={item.rich_text} />
                    </div>
                  )}
                </div>
              </S.ContentWrapper>
            </AccordionItem>
          ))}
        </Accordion>
      )}
    </S.Wrapper>
  );
}

SliceAccordion.componentName = 'accordion';
